import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ConfigProvider } from 'antd';
// import reportWebVitals from './reportWebVitals';

import './index.scss';
import 'animate.css';

const antdTheme = {
  token: {
    colorPrimary: '#2961ec',
    colorSecondary: '#045e60',
    borderRadius: 8,
    fontFamily: '"Jost", sans-serif',
  },
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ConfigProvider theme={antdTheme}>
      <App />
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
